export const messages = {
	'pref-assessment-date':
		'We always try to schedule your preferred time. Your appointment is NOT confirmed until you receive a booking email from us.',
	'change-user-role': `Only change a user's role when they are not signed in. They can sign back in afterward with their new role.`,
};
